import { createFileRoute } from '@tanstack/react-router';

import { PrepareInvoicePage } from '@/pages/invoicing/prepare/PrepareInvoicePage';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

export const Route = createFileRoute('/_authenticated/_app/invoicing/prepare/$orderId')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({ context, anyOf: ['invoicing.prepare'], redirectTo: '/dashboard' }),
	component: PrepareInvoicePage,
});
